import { Grid, Box,  } from '@mui/material';
import { DataGrid, GridToolbarContainer, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { memo, useState } from 'react';
import CustomNoRowsOverlay from 'components/CustomNoRowsOverlay';

const ReportsDataTable = ({rows=[], columns=[], options={}, tableBackgroundColor='inherit'}) => {
  const { pageSize=25 } = options;

  const [_pageSize, setPageSize] = useState(pageSize); 

  function CustomToolbar() {
    return (
      <GridToolbarContainer sx={{justifyContent:"right"}}>
        <GridToolbarQuickFilter />
        {/* <GridToolbarExport /> */}
      </GridToolbarContainer>
    );
  }

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{mt:3, mb: {xs: 10, md: 2}}}>
      <Box sx={{ height: '500px',width: '100%', background: tableBackgroundColor }}>
          <DataGrid 
            rows={rows?.length > 0 ? rows.map(row => ({...row, rowId: new Date().getTime() * Math.random()})) : []}
            columns={columns}
            pageSize={_pageSize}
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
              toolbar: CustomToolbar
              // toolbar: GridToolbar 
            }}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            pageSizeOptions={[10,25,50,100]}
            getRowId={(row) => row.rowId}
            // getRowHeight={() => 'auto'}
            // hideFooterSelectedRowCount
            disableSelectionOnClick
            // density='comfortable'
            // getColumnSpacing={()=> 5}
            // autoHeight={rows.length <= 8 ? true: false}
            // sx={{...dataGridTablePlainStyles}}
            disableColumnSelector
            disableDensitySelector
            disableRowSelectionOnClick
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
          />
      </Box>
    </Grid>
  );
}
 
export default memo(ReportsDataTable);